import { ArrowUpRightIcon } from "@heroicons/react/24/solid";
import React from "react";

import { cx } from "components/Graphs/utils";
import { BREV_SUPPORT_EMAIL } from "constants/index";

interface BillingSupportContactLinkProps {
  className?: string;
}

const BillingSupportContactLink: React.FC<BillingSupportContactLinkProps> = ({
  className,
}) => {
  return (
    <a
      className={cx(
        "inline-flex items-center text-sm text-highlight hover:text-highlightLighter",
        className,
      )}
      href={`mailto:${BREV_SUPPORT_EMAIL}`}
    >
      Contact us at <span className="ml-1 underline">{BREV_SUPPORT_EMAIL}</span>
      <ArrowUpRightIcon className="ml-1 h-4 w-4" aria-hidden="true" />
    </a>
  );
};

export default BillingSupportContactLink;
